export default __webpack_public_path__ + "static/media/video-plus.745c074d.svg";